module.exports = __webpack_public_path__ + "img/DSC_1896.318050aa.JPG";